import { Typography } from 'antd';
import styled from 'styled-components';

declare const TITLE_ELE_LIST: [1, 2, 3, 4];

interface EllipsisType {
  rows: number;
  expandable: boolean;
}

interface HSMSTypographyProps {
  type?: string | undefined;
  level?: typeof TITLE_ELE_LIST[number];
  strong?: boolean;
  ellipsis?: EllipsisType;
  children: React.ReactNode;
}

const TitleWrapper = styled.div`
  padding-bottom: 16px;
`;

const ParagraphWrapper = styled.div`
  padding: 13px 0;
`;

export const HSMSTypography = ({ type, level, strong, ellipsis, children }: HSMSTypographyProps) => {
  const { Title } = Typography;
  const { Text } = Typography;
  const { Paragraph } = Typography;

  if (type === 'title') {
    return (
      <TitleWrapper>
        <Title level={level}>{children}</Title>
      </TitleWrapper>
    );
  }
  if (type === 'paragraph') {
    return (
      <ParagraphWrapper>
        <Paragraph ellipsis={ellipsis} strong={strong}>
          {children}
        </Paragraph>
      </ParagraphWrapper>
    );
  }
  return <Text strong={strong}>{children}</Text>;
};
